// extracted by mini-css-extract-plugin
module.exports = {"CompanyName":"index-module_CompanyName_R0BMO"};